<template>
  <div
    v-for="(setting, key) in tabContent"
    :key="key"
    class="export-setting"
    :class="{ 'highlight indent': !setting.children }"
    @click.stop="!setting.children ? handleUpdateCheckbox(setting.label, !setting.value) : null"
  >
    <CheckBox
      v-if="!setting.children"
      :label="setting.label"
      :value="setting.value"
      :style="{ marginLeft: `${25 + tabLevel * 18}px` }"
      color="#e18d3d"
    />
    <div v-else>
      <div
        class="export-setting-container"
        @click.stop="handleUpdateCheckbox(setting.label, !setting.value)"
      >
        <v-btn
          :icon="setting.collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up'"
          :ripple="false"
          variant="text"
          :style="{ marginLeft: `${tabLevel * 18}px` }"
          class="export-setting-icon"
          @click.stop="setting.collapsed = !setting.collapsed"
        />
        <CheckBox
          :label="setting.label"
          :value="setting.value"
          color="#e18d3d"
        />
      </div>
      <!-- Recursive call to render nested settings.
       Must emit update-setting to make sure the event propagates to the parent. -->
      <MapFieldSettingOption
        v-if="!setting.collapsed"
        :tab-content="setting.children"
        :tab-level="tabLevel + 1"
        :full-path="fullPath ? `${fullPath}.${setting.label}` : setting.label"
        @update-setting="($event) => $emit('update-setting', $event)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import CheckBox from '@/components/Reusable/CheckBox.vue';
import {ExportFieldSetting} from '@/lib/classes/SharedMap/exportFields';
import {RefreshFieldSetting} from '@/services/RefreshService/types';
import {PropType} from 'vue';

export default {
  name: 'MapFieldSettingOption',
  components: {
    CheckBox,
  },
  props: {
    tabContent: {
      type: Array as PropType<ExportFieldSetting[] | RefreshFieldSetting[]>,
      required: true,
    },
    tabLevel: {
      type: Number,
      default: 0,
    },
    /* The full path for the label */
    fullPath: {
      type: String,
      default: '',
    },
  },
  emits: ['update-setting'],
  methods: {
    handleUpdateCheckbox(label: string, value: boolean) {
      const fullLabelPath = this.fullPath ? `${this.fullPath}.${label}` : label;
      this.$emit('update-setting', {label: fullLabelPath, value});
    },
  },
};
</script>

<style lang="scss" scoped>
.export-setting {
  &.highlight {
    &:hover {
      background-color: main.$lightGray;
      cursor: pointer;
    }
  }
  &.indent {
    padding-left: 12px;
  }
  :deep(.v-label) {
    color: main.$npGray;
    font-size: 14px;
    opacity: 100%;
    margin-left: 10px;
  }
  :deep(.v-input__details) {
    display: none;
  }
  :deep(.v-input__control) {
    height: 25px;
  }
  :deep(.v-selection-control) {
    min-height: 25px;
  }
  :deep(.v-selection-control__wrapper) {
    width: 20px;
    margin-left: 5px;
  }
  :deep(.v-selection-control__input) {
    color: main.$npOrange;
    width: 20px;
    height: 20px;
  }
  :deep(i) {
    font-size: 21px;
    opacity: 100%;
  }
  &-container {
    padding-left: 12px;
    display: flex;
    align-items: center;
    &:hover {
      background-color: main.$lightGray;
      cursor: pointer;
    }
  }
  &-icon {
    padding: 0px;
    width: 25px;
    height: 25px;
  }
}
</style>
